import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=55183b22&scoped=true"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55183b22",
  null
  
)

export default component.exports